/**
 * Shared highlight / unhighlight helpers for contenteditable editors.
 * Uses document.execCommand on the current selection (same as legacy Highlight buttons).
 */

export const HIGHLIGHT_COLOR = '#FF0000';
export const DEFAULT_TEXT_COLOR = '#000000';

export function getSelectedText() {
  const selection = window.getSelection();
  if (!selection || selection.rangeCount === 0) {
    return '';
  }
  return selection.toString();
}

function escapeRegex(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function appendSelectionToSummary(currentSummary, selectedText) {
  if (!selectedText) {
    return currentSummary;
  }
  if (currentSummary && currentSummary.length > 0) {
    return `${currentSummary}
            <br/>
            ${selectedText}`;
  }
  return selectedText;
}

export function removeSelectionFromSummary(currentSummary, selectedText) {
  if (!selectedText || !currentSummary) {
    return currentSummary;
  }
  const escaped = escapeRegex(selectedText.trim());
  if (!escaped) {
    return currentSummary;
  }
  let updated = currentSummary;
  const patterns = [
    new RegExp(`(<br\\s*/?>\\s*)+${escaped}`, 'gi'),
    new RegExp(escaped, 'g'),
  ];
  for (const pattern of patterns) {
    if (pattern.test(updated)) {
      updated = updated.replace(pattern, '');
      break;
    }
  }
  return updated.replace(/^(<br\s*\/?>\s*)+/gi, '').replace(/(<br\s*\/?>\s*)+$/gi, '').trim();
}

export function applyHighlightToSelection({ useBold = false } = {}) {
  document.execCommand('foreColor', false, HIGHLIGHT_COLOR);
  if (useBold) {
    document.execCommand('bold', false);
  }
  return getSelectedText();
}

export function removeHighlightFromSelection({ useBold = false } = {}) {
  document.execCommand('foreColor', false, DEFAULT_TEXT_COLOR);
  if (useBold && document.queryCommandState('bold')) {
    document.execCommand('bold', false);
  }
  return getSelectedText();
}

export function highlightWithSummaryUpdate(currentSummary, { useBold = false } = {}) {
  const selectedText = applyHighlightToSelection({ useBold });
  return appendSelectionToSummary(currentSummary, selectedText);
}

export function unhighlightWithSummaryUpdate(currentSummary, { useBold = false } = {}) {
  const selectedText = removeHighlightFromSelection({ useBold });
  return removeSelectionFromSummary(currentSummary, selectedText);
}
